module.exports = __webpack_public_path__ + "static/lokki-289x217-2463.2468774c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lokki-289x217-2463.jpg
// module id = 191
// module chunks = 199081029669686 269703637554175